import { ModuleRegistry } from "seneca-common/features/module/registry";

import { markAnswer } from "./logic/answers";
import { getModuleAssets, transformModuleAssets } from "./logic/assets";
import { generateContent } from "./logic/content";

export const MODULE_TYPE = "image";
export type TYPE = "image";
export { transformModuleAssets };

export const register = (moduleRegistry: ModuleRegistry) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateContent)
    .getModuleAssets(getModuleAssets)
    .back.staticInformation()
    .displayName("Image")
    .readOnly()
    .root.register();
